import { driverGroupSchema } from './driver-group.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const driverSchema = z.object({
  id: z.number(),
  name: z.string(),
  driverId: z.string(),
  modifiedOn: coercedDate,
  driverGroups: z.array(driverGroupSchema).optional(),
});

export const driverImportSchema = driverSchema
  .pick({
    name: true,
    driverId: true,
  })
  .extend({
    Groups: z.array(z.object({ driverGroupName: z.string() })).optional(),
  });

export type Driver = z.infer<typeof driverSchema>;

export type DriverImport = z.infer<typeof driverImportSchema>;
